@for (pair of meta(); track pair; let i = $index) {
<av-metadata-builder-pair
  #pair
  [item]="pair"
  [types]="types()"
  [keyLabel]="keyLabel()"
  [valueLabel]="valueLabel()"
  (updated)="itemUpdated($event, i)"
  (removed)="itemRemoved($event, i)"
>
  <ng-content select="[metadataHelp]"></ng-content>
</av-metadata-builder-pair>
} @if (isDuplicateKey()) {
<div translate class="form-error">Duplicate key detected</div>
} @if (isFieldMissing()) {
<div translate class="form-error">All fields are required</div>
}
<div>
  <ng-content></ng-content>
</div>
